import * as React from 'react';
import { compose, setDisplayName, withProps, withState } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';
import { Fade } from 'ui/transitions';
import { RecurrenceMonthlyDayNum } from './RecurrenceMonthlyDayNum';
import { RecurrenceMonthlyDay } from './RecurrenceMonthlyDay';

export type OwnProps = {
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};

const RawRecurrenceMonthly = (props: OwnProps & RecomposeProps & TranslateProps) =>
    <Fade
        id="edit-schedule-recurrence-panel-monthly"
        className="edit-schedule-recurrence-panel"
        visible={ props.enabled }
        duration={ 400 }
    >
        <div>
            <RecurrenceMonthlyDayNum { ...props }/>
            <RecurrenceMonthlyDay { ...props }/>
        </div>
    </Fade>
;

type RecomposeProps = {
    enabled: boolean;
    useDayNum: boolean;
    onChangeUseDayNum: (b: boolean) => void;
};

export const RecurrenceMonthly = compose<OwnProps & RecomposeProps & TranslateProps, OwnProps>(
    setDisplayName('RecurrenceMonthly'),
    translate(),
    withProps(({ reportSettings }: OwnProps) => ({
        enabled: reportSettings.scheduleType === 'Monthly',
    })),
    withState('useDayNum', 'onChangeUseDayNum', ({ reportSettings }: OwnProps) => reportSettings.useScheduleMonthlyDayNum),
)(RawRecurrenceMonthly);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/schedule/runOnSchedule/recurrence/RecurrenceMonthly.tsx